import { create } from '@bufbuild/protobuf'

import { useSourceDocument } from '@/api/source-document.hook'
import { DocumentQuote } from '@/gen/artifacts/v1/model_pb'
import { DocumentFactSchema } from '@/gen/inventory/v1/control_service_pb'

import { DocumentFactViewer } from '@/components/shared/document-fact-viewer/document-fact-viewer'
import { SourceDocumentStaticViewer } from '@/components/shared/source-document-static-viewer/source-document-static-viewer'

type SourceDocumentViewerProps = {
  documentQuote: DocumentQuote
  readonly?: boolean
}

export const SourceDocumentViewer = ({
  documentQuote,
  readonly = false,
}: SourceDocumentViewerProps) => {
  const { name, source, uploadedAt, expirationDate, page, subcategory } = documentQuote
  // Full-document citations reference the document only, with no verbatim text.
  // Drop empty entries so the card doesn't render a blank quote (mirrors
  // source-document-static-viewer).
  const entries = documentQuote.quoteEntries.filter((e) => e.text.trim() !== '')
  const quotes = entries.map((e) => e.text)
  const quoteContexts = entries.map((e) => e.context)

  const { link, fallbackLink } = useSourceDocument(documentQuote)

  if (!link || readonly) {
    return <SourceDocumentStaticViewer documentQuote={documentQuote} link={fallbackLink} />
  }

  return (
    <DocumentFactViewer
      fallbackLink={fallbackLink}
      quoteContexts={quoteContexts}
      documentFact={create(DocumentFactSchema, {
        expirationDate,
        uploadedAt,
        name,
        source,
        page,
        // page is undefined for non-PDF sources — only append #page= for PDFs
        link: page ? `${link}#page=${page}` : link,
        quotes,
        subcategory,
      })}
    />
  )
}
